// extracted by mini-css-extract-plugin
export default {"bullets":"Y3p4EMYY","bullet":"ICVxt6HW"};